import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

var getSize = () => {
  document.getElementById('landingPageCover').style.height = window.innerHeight + "px";
  document.getElementById('content').style.marginTop = window.innerHeight + "px";
}
getSize()
if (window.innerWidth > 768){
  window.addEventListener('resize', getSize);
}
